var React = require('react');

function IconAddCommentSolid (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M944.3 65.2H82.4c-8.9 0-16 7.1-16 16.1l-.5 874.4 189.9-190.9h688.6c8.8 0 16-7.2 17-18V79.1c-1.1-6.9-8.3-13.9-17.1-13.9zM735.5 437.6c0 6.2-5.1 11.3-11.3 11.3h-180V628c0 6.2-5.1 11.3-11.3 11.3h-43.6c-6.2 0-11.3-5.1-11.3-11.3V448.9H299.3c-6.2 0-11.3-5.1-11.3-11.3V394c0-6.2 5.1-11.3 11.3-11.3l178.7-1V201.1c0-6.2 5.1-11.3 11.3-11.3H533c6.2 0 11.3 5.1 11.3 11.3v181.6h180c6.2 0 11.3 5.1 11.3 11.3v43.6z"}));
}

IconAddCommentSolid.displayName = "IconAddCommentSolid";

IconAddCommentSolid.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconAddCommentSolid;

IconAddCommentSolid.default = IconAddCommentSolid;
